module.exports = __webpack_public_path__ + "static/media/photo282.ca4cb6b5.jpg";